// extracted by mini-css-extract-plugin
module.exports = {"action__body_mobile":"ProductCardDefault_action__body_mobile__sRgGb","actions__counter_mobile":"ProductCardDefault_actions__counter_mobile__n2Uf4"};